var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1111 4.53963C14.4634 4.18737 14.6614 3.70957 14.6615 3.21134C14.6615 2.71311 14.4637 2.23526 14.1114 1.88291C13.7592 1.53056 13.2814 1.33258 12.7831 1.33252C12.2849 1.33246 11.807 1.53032 11.4547 1.88258L2.56053 10.7788C2.4058 10.933 2.29137 11.123 2.22731 11.3319L1.34696 14.2322C1.32974 14.2898 1.32843 14.351 1.34319 14.4094C1.35795 14.4677 1.38822 14.5209 1.43079 14.5634C1.47336 14.6059 1.52664 14.6361 1.58498 14.6508C1.64332 14.6654 1.70454 14.664 1.76215 14.6467L4.66311 13.767C4.87182 13.7035 5.06175 13.5898 5.21625 13.4358L14.1111 4.53963Z",
    stroke: "#155DFC",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9943,
    height: 15.9943,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/Edit2.982ef37360efd9566291140a69df7e9b.svg";
export { ForwardRef as ReactComponent };